export default __webpack_public_path__ + "static/media/sendMessageButton.21b28e18.svg";